import {Component} from '@angular/core';

@Component({
    selector: 'sec-footer',
    templateUrl: './footer.component.html'
})

export class FooterComponent {
    footer = 'Institut Obert de Catalunya';
}
